import { Injectable } from '@angular/core';
import { CommunicationApiService } from './communication-api.service';
import { AnalyticsSearchDto } from './analytics-search.dto';
import { AnalyticsSearchResultDto } from './analytics-search-result.dto';
import { MemberEmailEngagementSearchResultDto } from './member-email-engagement-search-result.dto';
import { MemberEmailEngagementSearchDto } from './member-email-engagement-search.dto';
import { UndeliverableEmailSearchDto } from './undeliverable-email-search.dto';
import { NameValue, PagedResultGeneric } from 'src/app/shared';
import { UndeliverableEmailSearchResultDto } from './undeliverable-email-searchResult.dto';
import { ClickedEmailLinkSearchResultDto } from './clicked-email-link-search-result.dto';
import { ClickedEmailLinkSearchDto } from './clicked-email-link-search.dto';
import { MessageProfileIdSearchDto } from './message-profile-id-search.dto';
import { EmailSubscriptionSearchDto } from './email-subscription-search';
import { EmailSubscriptionLogDto } from './email-subscription-log.dto';
@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  public constructor(private _apiService: CommunicationApiService) {}

  public getDashBoardAnalytics(searchDto: AnalyticsSearchDto): Promise<AnalyticsSearchResultDto> {
    return this._apiService.post('communication/v2/DashboardAnalytics/dashboard-analytics', searchDto);
  }

  public getTopFiveMembersByEmailEngagement(
    searchDto: MemberEmailEngagementSearchDto
  ): Promise<Array<MemberEmailEngagementSearchResultDto>> {
    return this._apiService.post('communication/v2/DashboardAnalytics/members-email-engagement/top-five', searchDto);
  }

  public searchUndeliverableEmails(searchDto: UndeliverableEmailSearchDto): Promise<PagedResultGeneric<UndeliverableEmailSearchResultDto>> {
    return this._apiService.post('communication/v2/UndeliverableEmails/search', searchDto);
  }

  public exportUndeliverableEmails(searchDto: UndeliverableEmailSearchDto): Promise<string> {
    return this._apiService.post('communication/v2/UndeliverableEmails/export', searchDto);
  }

  public getTopFiveClickedLinks(searchDto: ClickedEmailLinkSearchDto): Promise<Array<ClickedEmailLinkSearchResultDto>> {
    return this._apiService.post('communication/v2/DashboardAnalytics/clicked-links/top-five', searchDto);
  }

  public getMessageProfileIds(searchOption: MessageProfileIdSearchDto): Promise<Array<number>> {
    return this._apiService.post('communication/v2/Message/Get-ProfileIds', searchOption);
  }

  public searchEmailSubscriptionLogs(searchOption: EmailSubscriptionSearchDto): Promise<PagedResultGeneric<EmailSubscriptionLogDto>> {
    return this._apiService.post('communication/v2/ProfileSubscription/emailSubscriptionLogs/search', searchOption);
  }
  public getEventConfirmationEmailSpecialFields(): Promise<Array<NameValue>> {
    return this._apiService.get('communication/v2/specialfield/event-confirmation-email').then((specialFields) => {
      if (!specialFields || !specialFields.map) {
        return specialFields;
      }

      return specialFields.map((x: any) => new NameValue(x.Name, x.Value));
    });
  }
}
